import { environment } from "src/environments/environment";

export class Config {

    static getEnv() {
        console.log(`Ambiente: ${environment.ambiente}`)
    }

    public static easyDocEndpoints = {
        auth: "/auth",
        authLogin: "auth/login",
        statsvc: "/statsvc?m=",
        finalizedVideoCall: "/statsvc/finalizedVideoCall?m=",
        statsBycid: "/statsvc/cid/",
        sendMedicEmail: "/report/postEmailMedic",
        recordVC: '/isRecording',
        consentRecording: '/consentRecording',
        memberCanEnter: '/memberCanEnter',
        uploadConsentSelection: '/vclogs/saveConsent',
        showConsent: '/vclogs/showConsent',
        sendPayload: "/dencrypt",
        sendMedicStatus: "/medicReady"
    };

    public static videoConsultaEndpoints = {
        room: "/room/",
        cid: "/cid",
    };

    public static authBody = {
        userName: 'userVideconsulta',
        password: 'cdt1345VC'
    }

    public static baseURL = environment.server
}

Config.getEnv()
